import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  redemCoupon,
  getCouponPartnerWise,
  getLeadsCouponWise,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";

class useCoupon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponCode: "",
      couponCodeMessage: "",
      couponData: [],
      mobile_no: "",
      mobileError: "",
      errormessages: [],
      couponcodeText: "",
      leadData: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Coupon</b> - redem successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    getCouponPartnerWise(obj).then((response1) => {
      console.log("partnerwise coupon", response1.data);
      this.setState({ couponData: response1.data });
    });
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  loadLeadList = (event) => {
    const target = event.target;
    const couponcodeText = target.selectedOptions[0].text;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    console.log(value, "target");
    this.setState({
      [name]: value,
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ couponcodeText: couponcodeText });
    getLeadsCouponWise(value, obj).then((response1) => {
      console.log(response1.data, "coupon wise lead");
      this.setState({ leadData: response1.data });
    });
  };
  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.couponcodeText.length == 0) {
      error = true;
      this.setState({
        coupon_codeError: (
          <small className="text-danger">Coupon code is required.</small>
        ),
      });
    } else {
      this.setState({ coupon_codeError: null });
    }

    if (this.state.mobile_no.length == 0) {
      error = true;
      this.setState({
        mobileError: (
          <small className="text-danger">Mobile number is required.</small>
        ),
      });
    } else {
      this.setState({ mobileError: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      redemCoupon(this.state.couponcodeText, this.state.mobile_no, obj)
        .then((res) => {
          console.log(res);
          if (res.data.success === false) {
            let message = res.data.message;

            var ermessage = [];
            ermessage.push(message);
            this.setState({ errormessages: ermessage });
            //  this.coupon_code_error.current.focus();
            this.setState({
              coupon_codeError: (
                <small className="text-danger">{message}</small>
              ),
            });
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              couponCodeText: "",
              mobile_no: "",
            });
          }
          // this.props.history.push('/admin/medication');
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  };
  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <ControlLabel>Coupon Code</ControlLabel>
                      <select
                        name="couponCode"
                        value={this.state.couponCode}
                        onChange={this.loadLeadList}
                        className="form-control"
                      >
                        <option value="">Select couponCode</option>
                        {this.state.couponData.map((coupon) => (
                          <option value={coupon.id}>
                            {coupon.coupon_code}
                          </option>
                        ))}
                      </select>

                      {this.state.coupon_codeError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Phone Number</ControlLabel>

                      <select
                        name="mobile_no"
                        value={this.state.mobile_no}
                        onChange={this.onChange}
                        className="form-control"
                      >
                        <option value="">Select Customer</option>
                        {this.state.leadData.map((lead) => (
                          <option value={lead.lead.mobile_no}>
                            {lead.lead.mobile_no}({lead.lead.name})
                          </option>
                        ))}
                      </select>

                      {this.state.mobileError}
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default useCoupon;
